import React from 'react';
import {
	ShowButton,
	ReferenceInput,
	SelectInput,
	Datagrid,
	TextField,
	FunctionField,
	Filter,
	TextInput
} from 'react-admin';
import AmountField from '../../components/fields/AmountField';
import TList from '../../components/wrapper/TList';
import WalletAccountListActions from './WalletAccountListActions';
import PropTypes from 'prop-types';

export const coreWalletAccountTypesForSelection = [
	'Main',
	'Shop',
	'Deposit',
	'LoyaltyProgram',
	'LoyaltyMember',
	'MarketPlace',
	'MarketCoupon',
	'MarketCustomer',
	'External',
	'FeeCompensation'
].map(key => {
	return { id: key, name: key };
});

const walletAccountStatusForSelection = ['Created', 'Active', 'Locked', 'Deleted'].map(key => {
	return { id: key, name: key };
});

const WalletAccountFilter = ({ walletAccountTypesForSelection, ...props }) => (
	<Filter {...props}>
		<TextInput source="walletId" defaultValue="" alwaysOn />
		<SelectInput
			alwaysOn
			resettable
			label="resources.walletAccounts.filter.type"
			source="walletAccountType"
			choices={walletAccountTypesForSelection}
		/>
		<SelectInput
			alwaysOn
			resettable
			label="resources.walletAccounts.filter.status"
			source="walletAccountStatus"
			choices={walletAccountStatusForSelection}
		/>
		<ReferenceInput alwaysOn source="currencyCode" reference="currencies">
			<SelectInput optionText="name" resettable />
		</ReferenceInput>
		<TextInput
			alwaysOn
			resettable
			label="resources.walletAccounts.filter.walletAccountQualifier"
			source="walletAccountQualifier"
		/>
		<TextInput
			alwaysOn
			resettable
			label="resources.walletAccounts.filter.externalAccountId"
			source="externalAccountId"
		/>
	</Filter>
);

const WalletAccountList = ({ walletAccountTypesForSelection, ...props }) => (
	<TList
		{...props}
		filters={
			<WalletAccountFilter
				walletAccountTypesForSelection={walletAccountTypesForSelection}
			/>
		}
		actions={<WalletAccountListActions />}
		sort={{ field: 'id', order: 'DESC' }}
	>
		<Datagrid>
			<ShowButton/>
			<TextField source="walletId" sortable={false} />
			<TextField source="walletAccountId" sortBy="id" />
			<TextField source="externalAccountId" />
			<TextField source="currency" />
			<TextField source="accountType" />
			<TextField source="accountStatus" />
			<AmountField source="accountBalance.balance" />
			<FunctionField
				source="accountName"
				sortable={false}
				render={record => (
					<span>
						{record.accountName}
						<br />
						{record.description || ''}
					</span>
				)}
			/>
		</Datagrid>
	</TList>
);

WalletAccountList.propTypes = {
	walletAccountTypesForSelection: PropTypes.array.isRequired
};

WalletAccountList.defaultProps = {
	walletAccountTypesForSelection: coreWalletAccountTypesForSelection
};

export default WalletAccountList;
